import {createAction} from '@reduxjs/toolkit';

export const reset = createAction('WIZARD_RESET');
export const setStep = createAction('WIZARD_SET_STEP');
export const setSortDirection = createAction('WIZARD_SET_SORT_DIRECTION');
export const enableMosaics = createAction('WIZARD_ENABLE_MOSAICS');
export const disableMosaics = createAction('WIZARD_DISABLE_MOSAICS');
export const setGridItemScale = createAction('WIZARD_SET_GRID_ITEM_SCALE');
export const openCreateDialog = createAction('WIZARD_OPEN_CREATE_DIALOG');
export const closeCreateDialog = createAction('WIZARD_CLOSE_CREATE_DIALOG');
